import template from './report_backup_managers.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportBackupManagersViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.search_string = ko.observable('');
		this.table_report = ko.observableArray();
		this.download_data = ko.observableArray();
		this.manager = ko.observableArray([]);
		this.backup_managers = ko.observable();

		this.current_department_id = ko.observable();
		this.current_company_id = ko.observable();
		this.backup_manager_id = ko.observable();

		this.selected_company = ko.observable();
		this.selected_department = ko.observable();
		this.selected_backup_manager = ko.observable();
		this.show_hint = ko.observable(true);
		this.show_no_data_message = ko.observable(false);

		this.sort_field = ko.observable('surname');
		this.sort_order = ko.observable('ASC');
		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(10);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([10, 20, 50, 100]);
		this.selected_number_of_records = ko.observable(10);

		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.page.load_table();
		});

		this.selected_company.subscribe((newValue) => {
			this.table_report([]);
			this.show_hint(true);
			if (newValue != null)
				this.current_company_id(newValue.company_id);
			else
				this.current_company_id(null);
		});

		this.selected_department.subscribe((newValue) => {
			this.table_report([]);
			this.show_hint(true);
			if (newValue != null)
				this.current_department_id(newValue.department_id);
			else
				this.current_department_id(null);
		});

		this.selected_backup_manager.subscribe((newValue) => {
			this.table_report([]);
			this.show_hint(true);
			if (newValue != null)
				this.backup_manager_id(newValue.employee_id);
			else
				this.backup_manager_id(null);
		});

		this.search_string.subscribe((newValue) => {
			if (newValue == '')
				this.backup_managers([]);
			else
				this.page.get_manager(newValue);
		});

		this.placeholderText = ko.pureComputed(() => {
			return this.selected_backup_manager() != null ? `Selected backup: ${this.selected_backup_manager().firstname} ${this.selected_backup_manager().surname}` : "Search backup...";
		});
	}

	sort_column(column)
	{
		if (column && column.trim() !== '')
		{
			if (this.sort_field() === column) 
				this.sort_order(this.sort_order() === 'ASC' ? 'DESC' : 'ASC');
			else
			{
				this.sort_field(column);
				this.sort_order('ASC');
			}
			this.page.load_table();
		}
	}

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.page.load_table();
	}

	backup_manager_click (selected)
	{
		this.search_string('');
		this.selected_backup_manager(selected);
	}

	clear_selected_option ()
	{
		this.search_string('');
		this.selected_backup_manager(null);
	}

	show_report_help()
	{
		Grape.dialog.open('BackupManagerReportHelp', { 'employee_id': this.page.bindings.id }, {});
	}

	update_click()
	{
		this.show_hint(false);
		this.page.updateData();
	}

	async download_clicked(v, e)
	{
		let my_manager_employee_options = {
			table: 'v_active_backup_manager',
			schema: 'savanna',
			offset: 0,
			limit: 1000000000,
			sortfield: 'surname',
			sortorder: 'ASC',
			filter: []
		};

		if (this.backup_manager_id())
		{
			my_manager_employee_options.filter.push({
				value: this.backup_manager_id(),
				operand: '=',
				field: 'backup_manager_id'
			});
		}

		if (this.current_company_id())
		{
			my_manager_employee_options.filter.push({
				value: this.current_company_id(), op: '=', field: 'company_id' 
			});
		}

		if (this.current_department_id())
		{
			my_manager_employee_options.filter.push({
				value: this.current_department_id(),
				operand: '=',
				field: 'department_id'
			})
		}
		console.log(my_manager_employee_options); 
		let res = await Grape.fetches.getJSON('/api/record',my_manager_employee_options);

		if (res)
		{
			if (res.records != null)
			{
				this.download_data(res.records);
				let csv_string = await Utils.table_to_csv(document.getElementById('tbl_employees_hidden'));

				if (csv_string === null || csv_string === undefined || csv_string === '')
					return;

				let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
				let link = document.createElement('a');

				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', 'backup_manager_report.csv');

				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}
}

class ReportBackupManagers
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportBackupManagersViewModel(this);
	}

	async init()
	{
		if (await Utils.redirectOnAccessDenied('ViewBackupManagerReport'))
			return;

		document.title = tr('Backup managers report');
		window.current_page_title(tr('Backup Manager Report'));
	}

	updateData()
	{
		this.load_table();
	}

	async load_table()
	{
		if (this.viewModel.show_hint()) return;
		this.viewModel.loader(true);
		let options = {
			table: 'v_active_backup_manager',
			schema: 'savanna',
			offset: (this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size(),
			limit: this.viewModel.current_page_size(),
			sortfield: this.viewModel.sort_field(),
			sortorder: this.viewModel.sort_order(),
			filter: []
		};

		if (this.viewModel.current_company_id())
		{
			options.filter.push({
				value: this.viewModel.current_company_id(),
				operand: '=',
				field: 'company_id'
			});
		}

		if (this.viewModel.current_department_id())
		{
			options.filter.push({
				value: this.viewModel.current_department_id(),
				operand: '=',
				field: 'department_id'
			});
		}

		if (this.viewModel.backup_manager_id())
		{
			options.filter.push({
				value: this.viewModel.backup_manager_id(),
				operand: '=',
				field: 'backup_manager_id'
			});
		}

		let res = await Grape.fetches.getJSON('/api/record', options);

		if (res && res.records != null)
		{
			this.viewModel.table_report(res.records);
			this.viewModel.show_hint(false);
			this.viewModel.page_count(Math.ceil(res.total / this.viewModel.current_page_size()));
			this.viewModel.pagination_summary(
				`Showing ${(this.viewModel.current_page_number() - 1) * this.viewModel.current_page_size() + 1} to ${Math.min(this.viewModel.current_page_number() * this.viewModel.current_page_size(), res.total)
				} of ${res.total} entries`
			);
		}

		if (res.total < 1)
			this.viewModel.show_no_data_message(true);

		this.viewModel.loader(false);
	}

	async get_manager(value)
	{
		let options = {
			table: 'v_manager_department',
			schema: 'savanna',
			limit: 10000,
			filter: [],
			filter_join: 'OR'
		};




		if (this.viewModel.search_string() && this.viewModel.search_string() != '')
		{
			options.filter.push({
				field: 'firstname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`
			}, {
				field: 'surname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`
			});
		}

		let result = await Grape.fetches.getJSON('/api/record', options);

		if (result.status != 'ERROR' && result.records != null)
		{
			let current_company_id = this.viewModel.current_company_id();
			let current_department_id = this.viewModel.current_department_id();
			let filtered_records = result.records.filter(record => {
				let match_company = !current_company_id || record.company_id == current_company_id;
				let match_department = !current_department_id || record.department_id == current_department_id;
				let match_active = record.active == true;
				return match_company && match_department && match_active;
			});


			let unique_records = [];
			let seen_ids = new Set();

			for (const record of filtered_records) {
				if (!seen_ids.has(record.employee_id)) {
					seen_ids.add(record.employee_id);
					unique_records.push(record);
				}
			}

			this.viewModel.backup_managers(unique_records);
		}
		else 
			this.viewModel.backup_managers([]);
	}
}

export default {
	route: '[/]report/report_backup_managers',
	page_class: ReportBackupManagers,
	template: template,
	template_filename: 'translation/report_backup_managers'
};
